export interface IValueRange {
    id: string;
    name: string;
}

export interface ICalculatedValues {
    position: number;
    count: number;
    value: number;
    valueRange: IValueRange;
}

export class CalculatedValues implements ICalculatedValues {
    position: number;
    count: number;
    value: number;
    valueRange: IValueRange;
    decimals:number;

    constructor(position: number,
        count: number,
        value: number,
        valueRange: IValueRange,
        decimals:number
    ) {
        this.position = position;
        this.count = count;
        this.value = value;
        this.valueRange = valueRange;
        this.decimals = decimals;
    }
}

export interface ICalculatedDetails {
    id: string;
    name: string;
    unit: string;
    calculatedValues: ICalculatedValues[];
    decimals:number;
    setCalculatedValues(counts: number, position: number, value: number, valueRange: string): void;
}

export class CalculatedDetails implements ICalculatedDetails {
    id: string;
    name: string;
    unit: string;
    calculatedValues: ICalculatedValues[];
    decimals: number;
    constructor(id: string,
        name: string,       
        unit: string,
        calculatedValues: ICalculatedValues[],
    ) {
        this.id = id;
        this.name = name;
        this.unit = unit;
        this.calculatedValues = calculatedValues;
    }


    setCalculatedValues(counts: number, position: number, value: number, valueRange: string): void {
    }
}

const defaultCalculatedDetails = new CalculatedDetails("", "", "", []);
export { defaultCalculatedDetails };
